import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox as CheckboxDS } from '@jisr-hr/design-system'
import i18n from 'translations/i18n'

const Checkbox = ({ input, label, handleOnChange, testId, ...props }) => (
  <CheckboxDS
    {...props}
    label={label && i18n.t(label)}
    onChange={(val, e) => {
      input.onChange(val)
      handleOnChange(val, e)
    }}
    checked={Boolean(input.value)}
    size="small"
    testId={testId}
  />
)

Checkbox.propTypes = {
  testId: PropTypes.string,
  label: PropTypes.string,
  input: PropTypes.shape(),
  handleOnChange: PropTypes.func,
}

Checkbox.defaultProps = {
  handleOnChange: () => {},
}

export default Checkbox
